<template>
  <SelectMultipleInput
    :label="labelComputed"
    :disabled="disabledComputed"
    v-model="model"
    :items="judgeItems"
    :loading="loading"
    itemText="name"
    itemValue="value"
    :required="required"
  />
</template>

<script>
import SelectMultipleInput from '@/components/atoms/base/select/SelectMultipleInput'
import { PartJudge } from '@/enum'

export default {
  name: 'JudgeMultipleInput',

  components: { SelectMultipleInput },

  props: {
    value: {
      type: Array,
      default: () => [],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0181')
      },
    },
    judgeItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(PartJudge).map((item) => {
          return { name: item + ' : ' + this.$t(`PartJudge.${item}`), value: item }
        })
      },
    },
    disabledComputed: {
      get() {
        return this.disabled
      },
    },
  },
}
</script>
